// extracted by mini-css-extract-plugin
export default {"dangerButton":"UiDangerButton_dangerButton_fxY_G"};